import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Grid from '@material-ui/core/Grid';
import { withRouter, RouteComponentProps, useLocation } from 'react-router-dom';
import { useUserContext } from '../context/UserContext'
import { userTypes, AuthRoutes, AdminRoutes } from '../app/enums';
import SearchIcon from '@material-ui/icons/Search';
import AccessTime from '@material-ui/icons/AccessTime';
import ReceiptIcon from '@material-ui/icons/Receipt';
import EmojiTransportationIcon from '@material-ui/icons/EmojiTransportation';
import EditLocationOutlinedIcon from '@material-ui/icons/EditLocationOutlined';
import PeopleIcon from '@material-ui/icons/People';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles ({
    icon: {
      color: theme.palette.primary.dark,
      size: 'large',
    },
    active: {
      backgroundColor: theme.palette.secondary.light,
      flexDirection: 'column',
      padding: theme.spacing(1, 0, 1),
    },
    mainListItem: {
      flexDirection: 'column',
      alignItems: 'center',
      padding: theme.spacing(1, 0, 1),
    },
    fontSmall: {
      fontSize: 12,
      color: theme.palette.text.primary,
    },
  }),
);

export const MainListItems: React.FC<RouteComponentProps> = (
  props: RouteComponentProps
) => {
  const { history } = props;
  const classes = useStyles();
  const { state } = useUserContext();
  const location = useLocation();

  const internalMenuItems = [
    {
      text: 'Search',
      icon: <SearchIcon className={classes.icon} fontSize="large"/>,
      path: AdminRoutes.adminSearch
    },
    {
      text: 'Rules',
      icon: <EmojiTransportationIcon className={classes.icon} fontSize="large"/>,
      path: AdminRoutes.rules
    },
    {
      text: 'Users',
      icon: <PeopleIcon className={classes.icon} fontSize="large"/>,
      path: AdminRoutes.users
    },
    {
      text: 'Locations',
      icon: <EditLocationOutlinedIcon className={classes.icon} fontSize="large"/>,
      path: AdminRoutes.locations
    }
  ]

  const externalMenuItems = [
    {
      text: 'Search',
      icon: <SearchIcon className={classes.icon} fontSize="large"/>,
      path: AuthRoutes.search
    },
    {
      text: 'Search History',
      icon: <AccessTime className={classes.icon} fontSize="large"/>,
      path: AuthRoutes.searchHistory
    },
    {
      text: 'Orders',
      icon: <ReceiptIcon className={classes.icon} fontSize="large"/>,
      path: AuthRoutes.orders
    },
  ]

  const defaultMenuItems = [
    {
      text: 'Search',
      icon: <SearchIcon className={classes.icon} fontSize="large"/>,
      path: AuthRoutes.search
    },
  ]

  const menuItems = state.self.id === '' 
    ? defaultMenuItems
    : state.self.userType === userTypes.INTERNAL 
      ? internalMenuItems 
      : externalMenuItems
      
  return(
    <List>
    {menuItems.map(item => (
      <ListItem
        button
        key={item.text}
        onClick={() => history.push(item.path)}
        className= {location.pathname === item.path ? classes.active : classes.mainListItem}
      >
        <ListItemIcon>
          <Grid container justifyContent="center">
            {item.icon}
          </Grid> 
        </ListItemIcon>
        <ListItemText primary = {item.text} classes={{primary:classes.fontSmall}}/>
      </ListItem>
    ))}
    </List>
  )};

export default withRouter(MainListItems);
